import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import Servicos from "./pages/Servicos";
import Blog from "./pages/Blog";
import ReformaTennantM20 from "./pages/ReformaTennantM20";
import ReformaTennantA5 from "./pages/ReformaTennantA5";
import LocacaoLavadoraPiso from "./pages/LocacaoLavadoraPiso";
import EquipamentosDisponiveis from "./pages/EquipamentosDisponiveis";
import FAQLocacaoLavadoraPiso from "./pages/FAQLocacaoLavadoraPiso";
import LocacaoBH from "./pages/LocacaoBH";
import LocacaoContagem from "./pages/LocacaoContagem";
import LocacaoBetim from "./pages/LocacaoBetim";
import LocacaoNovaLima from "./pages/LocacaoNovaLima";
import LocacaoMinasGerais from "./pages/LocacaoMinasGerais";
import LocacaoHospital from "./pages/LocacaoHospital";
import LocacaoSupermercado from "./pages/LocacaoSupermercado";
import LocacaoCondominio from "./pages/LocacaoCondominio";
import LocacaoIndustria from "./pages/LocacaoIndustria";
import LocacaoShopping from "./pages/LocacaoShopping";
import LimpezaPosObra from "./pages/LimpezaPosObra";
import LimpezaPosObraBH from "./pages/LimpezaPosObraBH";
import LimpezaPosObraContagem from "./pages/LimpezaPosObraContagem";
import LimpezaPosObraMarioCampos from "./pages/LimpezaPosObraMarioCampos";
import LimpezaPosObraBetim from "./pages/LimpezaPosObraBetim";
import LimpezaPosObraNovaLima from "./pages/LimpezaPosObraNovaLima";
import LimpezaPosObraGalpoes from "./pages/LimpezaPosObraGalpoes";
import LimpezaPosObraIndustrial from "./pages/LimpezaPosObraIndustrial";
import LimpezaPisoPosObra from "./pages/LimpezaPisoPosObra";
import CustoLimpezaPosObra from "./pages/blog/CustoLimpezaPosObra";
import LimpezaPosObraResidencial from "./pages/blog/LimpezaPosObraResidencial";
import LimpezaGalpaoIndustrial from "./pages/blog/LimpezaGalpaoIndustrial";
import LimpezaVsConvencional from "./pages/blog/LimpezaVsConvencional";
import RemoverCimentoArgamassa from "./pages/blog/RemoverCimentoArgamassa";
import LimpezaCondominios from "./pages/blog/LimpezaCondominios";
import EquipamentosLimpeza from "./pages/blog/EquipamentosLimpeza";
import LimpezaComercial from "./pages/blog/LimpezaComercial";
import TempoLimpeza from "./pages/blog/TempoLimpeza";
import ErrosConstrutoras from "./pages/blog/ErrosConstrutoras";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/reforma-tennant-m20" element={<ReformaTennantM20 />} />
            <Route path="/reforma-tennant-a5" element={<ReformaTennantA5 />} />
            <Route path="/locacao-lavadora-piso" element={<LocacaoLavadoraPiso />} />
            <Route path="/equipamentos-disponiveis" element={<EquipamentosDisponiveis />} />
            <Route path="/faq-locacao-lavadora-piso" element={<FAQLocacaoLavadoraPiso />} />
            
            {/* Limpeza Pós-Obra */}
            <Route path="/limpeza-pos-obra" element={<LimpezaPosObra />} />
            <Route path="/limpeza-pos-obra-belo-horizonte" element={<LimpezaPosObraBH />} />
            <Route path="/limpeza-pos-obra-contagem" element={<LimpezaPosObraContagem />} />
            <Route path="/limpeza-pos-obra-betim" element={<LimpezaPosObraBetim />} />
            <Route path="/limpeza-pos-obra-nova-lima" element={<LimpezaPosObraNovaLima />} />
            <Route path="/limpeza-pos-obra-mario-campos" element={<LimpezaPosObraMarioCampos />} />
            <Route path="/limpeza-pos-obra-galpoes" element={<LimpezaPosObraGalpoes />} />
            <Route path="/limpeza-pos-obra-industrial" element={<LimpezaPosObraIndustrial />} />
            <Route path="/limpeza-piso-pos-obra" element={<LimpezaPisoPosObra />} />
            
            {/* Artigos de Blog */}
            <Route path="/blog/custo-limpeza-pos-obra" element={<CustoLimpezaPosObra />} />
            <Route path="/blog/limpeza-pos-obra-residencial" element={<LimpezaPosObraResidencial />} />
            <Route path="/blog/limpeza-galpao-industrial" element={<LimpezaGalpaoIndustrial />} />
            <Route path="/blog/limpeza-vs-convencional" element={<LimpezaVsConvencional />} />
            <Route path="/blog/remover-cimento-argamassa" element={<RemoverCimentoArgamassa />} />
            <Route path="/blog/limpeza-condominios" element={<LimpezaCondominios />} />
            <Route path="/blog/equipamentos-limpeza-pos-obra" element={<EquipamentosLimpeza />} />
            <Route path="/blog/limpeza-comercial" element={<LimpezaComercial />} />
            <Route path="/blog/tempo-limpeza-pos-obra" element={<TempoLimpeza />} />
            <Route path="/blog/erros-construtoras" element={<ErrosConstrutoras />} />
            
            {/* Páginas Geográficas */}
            <Route path="/locacao-lavadora-piso-belo-horizonte" element={<LocacaoBH />} />
            <Route path="/locacao-lavadora-piso-contagem" element={<LocacaoContagem />} />
            <Route path="/locacao-lavadora-piso-betim" element={<LocacaoBetim />} />
            <Route path="/locacao-lavadora-piso-nova-lima" element={<LocacaoNovaLima />} />
            <Route path="/locacao-lavadora-piso-minas-gerais" element={<LocacaoMinasGerais />} />
            
            {/* Páginas de Segmentos */}
            <Route path="/locacao-lavadora-piso-hospital" element={<LocacaoHospital />} />
            <Route path="/locacao-lavadora-piso-supermercado" element={<LocacaoSupermercado />} />
            <Route path="/locacao-lavadora-piso-condominio" element={<LocacaoCondominio />} />
            <Route path="/locacao-lavadora-piso-industria" element={<LocacaoIndustria />} />
            <Route path="/locacao-lavadora-piso-shopping" element={<LocacaoShopping />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
